const isProduction = process.env.NODE_ENV === 'production';

export const getApiBaseUrl = () => {
  if (isProduction) {
    return `https://${window.location.host}/api`;
  }

  return process.env.REACT_APP_API_URL;
};

export const getWsBaseUrl = () => {
  if (isProduction) {
    return `wss://${window.location.host}`;
  }

  return process.env.REACT_APP_WS_URL;
};
